// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"90dae0fb","239":"900ed24e","455":"9ab82fea","488":"adc38f66"}[chunkId] + ".chunk.js";
};